import React from "react";

const EmailSorting = () => {
  return (
    <div style={{ padding: 0, margin: 0 }}>
      <iframe
        src="https://suppressionagent.livauto.com/MailSorter/"
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
        }}
        title="Email Sorting"
      ></iframe>
    </div>
  );
};

export default EmailSorting;
